import { useQuery } from '@tanstack/react-query'
import { dashboardApi } from '../api/dashboardApi'
import type { DashboardResponse } from '../types/dashboard'

export const useGetDashboard = (enabled = true) => {
  return useQuery<DashboardResponse>({
    queryKey: ['dashboard'],
    queryFn: dashboardApi.getDashboard,
    enabled,
  })
}
